// src/pages/portal/Page_Institution_Profile/Page_Institution_Profile.js
import React, { useState, useEffect } from "react";
import { Container, Grid, Header, Loader } from "semantic-ui-react";
import { useAuth } from "../../../../hooks";
import { InstitutionApi } from "../../../../api";
import {
  InstitutionProfile,
  InstitutionPlan,
  InstitutionPubli,
} from "../../../../components/Admin/InstitutionCmp/InstitutionProfile";
// La importación del SCSS ya está aquí, ¡perfecto!
import "./Page_Institution_Profile.scss";

export function Page_Institution_Profile() {
  const { user, accessToken } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      if (!user?.user?.institutions?.length) return;
      const id = user.user.institutions[0];
      const { institution } =
        await new InstitutionApi().getInstitutionsbyInstitution(
          accessToken,
          id,
          true,
        );
      setData(institution);
    })();
  }, [user, accessToken]);

  if (!data) {
    return <Loader active inline="centered" />;
  }

  return (
    // ANTES: <Container style={{ padding: "2em 1em" }}>
    // DESPUÉS: Usamos nuestra nueva clase BEM
    <Container className="page-institution-profile">
      <Header as="h2" dividing>
        Perfil de la Institución
      </Header>
      <Grid stackable columns={2}>
        <Grid.Column width={8}>
          <InstitutionProfile data={data} />
        </Grid.Column>
        <Grid.Column width={8}>
          <InstitutionPlan data={data} />
        </Grid.Column>
      </Grid>
      {/* F5: la card de Suscripcion vive en Soporte (decision Antonio). */}
      <InstitutionPubli url={data.website} />
    </Container>
  );
}
